import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ListItemButton, ListItemText } from '@mui/material';
import React from 'react';
import { NavLink as Link } from 'react-router-dom';

export interface IMenuItem {
  icon: IconProp;
  to: string;
  id?: string;
  'data-cy'?: string;
  style?: React.CSSProperties;
}

export default class MenuItem extends React.Component<IMenuItem> {
  render() {
    const { to, children, style } = this.props;
    const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

    return (
      <ListItemButton
        component={Link}
        style={style}
        to={to}
        data-cy={this.props['data-cy']}
        sx={{
          '&:hover': {
            color: initialTheme === 'light' ? '#000814' : '#ABADC6',
          },
        }}
      >
        <ListItemText
          primary={children}
          primaryTypographyProps={{
            fontSize: '14px',
          }}
          sx={{ pl: { xs: '60px', md: '73px' } }}
        />
      </ListItemButton>
    );
  }
}
